import { render } from "./UndoMessage.vue?vue&type=template&id=066d81e5&scoped=true"
import script from "./UndoMessage.vue?vue&type=script&lang=js"
export * from "./UndoMessage.vue?vue&type=script&lang=js"

import "./UndoMessage.vue?vue&type=style&index=0&id=066d81e5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066d81e5"]])

export default __exports__